import * as React from "react";

function SparklesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M327.5 85.19 384 64l21.2-56.509C406.9 2.985 411.2 0 416 0c4.8 0 9.1 2.985 10.8 7.491L448 64l56.5 21.19c4.5 1.69 7.5 6 7.5 10.81 0 4.8-3 9.1-7.5 10.8L448 128l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5-4.8 0-9.1-3-10.8-7.5L384 128l-56.5-21.2c-5.4-1.7-7.5-6-7.5-10.8 0-4.81 2.1-9.12 7.5-10.81zM257.8 187.3l114 52.7c5.7 2.6 9.3 8.3 9.3 14.6 0 6.2-3.6 11.9-9.3 14.5l-114 52.7-52.7 114c-2.6 5.7-8.3 9.3-14.5 9.3-6.3 0-12-3.6-14.6-9.3l-52.7-114L9.292 269.1C3.627 266.5 0 260.8 0 254.6c0-6.3 3.627-12 9.292-14.6L123.3 187.3 176 73.29c2.6-5.66 8.3-9.29 14.6-9.29 6.2 0 11.9 3.63 14.5 9.29l52.7 114.01zm147.4 140.2c1.7-5.4 6-7.5 10.8-7.5 4.8 0 9.1 2.1 10.8 7.5L448 384l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8 0 4.8-3 9.1-7.5 10.8L448 448l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5-4.8 0-9.1-3-10.8-7.5L384 448l-56.5-21.2c-5.4-1.7-7.5-6-7.5-10.8 0-4.8 2.1-9.1 7.5-10.8L384 384l21.2-56.5z"
  }));
}

const ForwardRef = React.forwardRef(SparklesIcon);
export default ForwardRef;